import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: null }),
  backgroundImage: belongsTo('asset', { inverse: null }),
  backgroundVideo: belongsTo('asset', { inverse: null }),
  contentItems: hasMany('content-item', { inverse: 'page' }),
  mlp: belongsTo('mlp', { inverse: 'pages' }),
  seoImage: belongsTo('asset', { inverse: null }),
});
